import React, { Component } from 'react';
import App_data from '../../../config/App_data';
import FD from '../../../RestAPI/fetchData';
import language from '../../../../assets/languages/language';
import { messages } from '../../../../common/messages';
import { EXAM_NAMES } from '../../../../common/constant';
import QuestionModeSetting from '../../../../Components-2025/QuestionModeSetting';

class SOA_P_QuestionBank extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alert_status: false,
      MessageTitle: `${language.LC().ALERT}`,
      MessageContent: `${language.LC().ERROR}`,
      chapters: [],
      freeChapterCount: [],
      token: '',
      idname: '',
      ValidToken: false,
      chapter_id: '',
      offset: 0,
      limit: 10,
      lastRecord: '',
      lastAttempt: false,
    };
    this.toggleAlert = this.toggleAlert.bind(this);
    //this._getReadings = this._getReadings.bind(this);
  }

  static contextTypes = { router: React.PropTypes.object };

  toggleAlert() {
    this.setState({ alert_status: !this.state.alert_status });
  }

  _getReadings = (chapter, e) => {
    this.context.router.push({
      pathname: `/soa/probability/readings/${chapter.chapter_no}/${chapter.chapter_name}`,
      state: {
        token: this.state.token,
        idname: this.state.idname,
        chapter: chapter.chapter_no,
        chapterName: chapter.chapter_name,
      },
    });
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    const storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    if (localStorage.getItem('selectedmenu') === 'frm') {
      this.context.router.push({
        pathname: '/frm/questionbank/',
        state: {
          token: storage_session['token'],
          idname: storage_session['idname'],
        },
      });
    }

    const data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
    };
    FD.callAPI(`${App_data.backend_api}/soa_p_question_bank/getChapters`, data).then(
      async (resp) => {
        // console.log(resp)
        if (resp.success) {
          this.setState({
            ValidToken: true,
            chapters: resp.chapters,
            freeChapterCount: resp.freeChapterCount,
          });
          await FD.callAPI(
            `${App_data.backend_api}/soa_p_question_bank/getlastAnsweredQuestion`,
            data,
          ).then((response) => {
            if (response.success) {
              this.setState({
                lastRecord: response.data,
                lastAttempt: true,
              });
            }
          });
        } else {
          this.setState({ ValidToken: false });
        }
        return resp;
      },
    );
  }

  goToQuestion = async () => {
    const { lastRecord, lastAttempt } = this.state;
    if (lastAttempt) {
      this.context.router.push({
        pathname: `/soa/probability/beginchapter/${lastRecord.soa_p_question.chapter_id}/${
          lastRecord.soa_p_question.reading_id
        }/${lastRecord.soa_p_question.id}/${lastRecord.soa_p_question.chapter_id}/${0}`,
        state: {
          token: this.state.token,
          idname: this.state.idname,
          reading: lastRecord.soa_p_question.reading_id,
          chapter: lastRecord.soa_p_question.chapter_id,
          offset: 0,
        },
      });
    }
  };

  render() {
    const chapters = this.state.chapters;
    const countFree = this.state.freeChapterCount;
    const { lastAttempt } = this.state;
    let data = '';
    const percent_data = [
      '23-30%', //General Probability
      '44-50%', // Univariate Random Variables
      '23-30%', //Multivariate Random Variables
    ];
    if (this.state.chapters.length && this.state.freeChapterCount.length) {
      data = chapters.map((item, index) =>
        countFree.map((itemFree, indexFree) =>
          item.chapter_no === itemFree.id ? (
            <div
              className='col-md-6 col-lg-6 col-xl-4 free-premium-section question_box'
              key={index}
            >
              <div
                className='question_bank_wrap pointer_class'
                key={item.id}
                onClick={this._getReadings.bind(this, item)}
              >
                <div className='margin_bottom_30'>
                  <img
                    src={`${App_data.frontend_url}/img/question_bank/icon2.svg`}
                    className=''
                    width='54'
                    alt=''
                  />
                </div>

                <div className='question_title' key={item.id} value={item.id}>
                  <a
                    className='pointer_class'
                    id={item.chapter_name}
                    value={item.chapter_no}
                    onClick={this._getReadings.bind(this, item)}
                  >
                    {item.chapter_no}. {item.chapter_name}
                  </a>
                </div>

                <ul key={item.chapter_name}>
                  <li>
                    <span>
                      <img
                        src={`${App_data.frontend_url}/img/question_bank/free_reading_icon.svg`}
                        className=''
                        width='25'
                        alt=''
                      />
                    </span>
                    <span>{percent_data[index]}</span>
                    {/* <span>{item.Countreading}</span> */}
                    {/* <div className='tootip_box'>
                      {language.LC().TOTAL_READINGS}
                    </div> */}
                  </li>
                  <li>
                    <span>
                      <img
                        src={`${App_data.frontend_url}/img/question_bank/free_question_icon.svg`}
                        className=''
                        width='26'
                        alt=''
                      />
                    </span>
                    <span>{itemFree.count}</span>
                    <div className='tootip_box'>{language.LC().FREE_QUESTIONS}</div>
                  </li>
                  <li>
                    <span>
                      <img
                        src={`${App_data.frontend_url}/img/question_bank/premium_question_icon.svg`}
                        className=''
                        width='23'
                        alt=''
                      />
                    </span>
                    <span>{item.Countquestion}</span>
                    <div className='tootip_box'>{language.LC().PREMIUM_QUESTIONS}</div>
                  </li>
                </ul>
              </div>
            </div>
          ) : null,
        ),
      );
    } else {
      data = (
        <div className='loader_box'>
          <div className='sk-circle'>
            <div className='sk-circle1 sk-child' />
            <div className='sk-circle2 sk-child' />
            <div className='sk-circle3 sk-child' />
            <div className='sk-circle4 sk-child' />
            <div className='sk-circle5 sk-child' />
            <div className='sk-circle6 sk-child' />
            <div className='sk-circle7 sk-child' />
            <div className='sk-circle8 sk-child' />
            <div className='sk-circle9 sk-child' />
            <div className='sk-circle10 sk-child' />
            <div className='sk-circle11 sk-child' />
            <div className='sk-circle12 sk-child' />
          </div>
        </div>
      );
    }
    return (
      <div className='animated fadeIn'>
        <div className='margin_bottom_20 d-flex justify-content-between last_question_read'>
          <h1 className='section_head'>{language.LC().SOA_PROBABILITY_QUESTION_BANK}</h1>
          <QuestionModeSetting examNameKey={EXAM_NAMES.SOA_P} />
          {lastAttempt && (
            <button
              className='btn btn-primary pointer_class'
              onClick={this.goToQuestion}
              disabled={!lastAttempt}
            >
              {messages.GO_TO_MY_LAST_QUESTION_ANSWERED}
            </button>
          )}
        </div>
        <div className='row'>
          <div className='col-sm-12 col-md-12 seperator-block-wrap'>
            <div className='card'>
              <div className='card-block'>
                <div className='card-block'>
                  <div className='row'>{data}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SOA_P_QuestionBank;



// WEBPACK FOOTER //
// ./src/views/SOA/Probability/QuestionBank/QuestionBank.js